import { Trans, useLingui } from '@lingui/react/macro'
import { Badge } from 'designSystem/components/Badge'
import { Button } from 'designSystem/components/Button'
import { Camera, X } from 'lucide-react'
import type { FC } from 'react'
import styled from 'styled-components'

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
`

export const PhotoModeHeader: FC<{ onExit: () => void }> = ({ onExit }) => {
  const { t } = useLingui()

  return (
    <Row>
      <Badge variant='secondary'>
        <Camera data-icon='inline-start' />
        <Trans>Photo mode</Trans>
      </Badge>
      <Button
        type='button'
        variant='ghostMuted'
        size='lg'
        title={t`Leave photo mode`}
        onClick={onExit}>
        <X data-icon='inline-start' />
        <Trans>Exit</Trans>
      </Button>
    </Row>
  )
}
